import React from 'react';

import BSAColorLogo from '../../../../assets/images/BSAColorLogo.svg';
import styles from './BSALogo.less';

interface BSALogoProps {
  className?: string;
}

const BSALogo = ({ className, ...props }: BSALogoProps) => (
  <span className={className} {...props}>
    <BSAColorLogo className={styles.icon} />
  </span>
);

export default BSALogo;
